<template>
  <div class="header">
    <div :class="isWide ? 'contain-full' : 'container'" class="row-start">
      <div v-show="showBack" class="px-4 cursor-hand" @click="onBack()"><i class="iconfont icon-arrowleft" /></div>
      <div v-show="hasLeftbar" class="px-4 hidden-sm-and-up cursor-hand" @click="onShowLeftbarDrawer"><span class="iconfont icon-menu" /></div>
      <a v-show="!showBack" href="//bahuyun.com" class="my-logo mx-4">
        <img
          alt="logo"
          :src="logoURL"
          style="display: block;height: 20px; margin-right: 30px"
        >
      </a>
      <div class="grow" />
      <div class="hidden-xs-only px-4 cursor-hand" :class="{'has-text-primary': $route.path == `/org/me`}" @click="handleSelect('/org/me')">工作区</div>
      <div class="hidden-xs-only px-4 cursor-hand" :class="{'has-text-primary': $route.path == `/tpl/list`}" @click="handleSelect('/tpl/list')">模板中心</div>
      <div class="hidden-xs-only px-4 cursor-hand" @click="handleSelect('price')">会员特权</div>
      <div class="hidden-xs-only px-4 cursor-hand" @click="handleSelect('help')">帮助文档</div>
      <div class="hidden-sm-and-up" @click.stop>
        <el-dropdown trigger="click" @command="handleSelect">
          <div class="px-4 cursor-hand iconfont icon-ellipsis" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/org/me">工作区</el-dropdown-item>
            <el-dropdown-item command="/tpl/list">模板中心</el-dropdown-item>
            <el-dropdown-item command="price">会员特权</el-dropdown-item>
            <el-dropdown-item command="help">帮助文档</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="" @click.stop>
        <el-dropdown trigger="click" @command="handleSelect">
          <div class="px-4 cursor-hand iconfont icon-user" />
          <el-dropdown-menu slot="dropdown">
            <div class="is-fs-m py-2 px-5 border-b">{{ token && userInfo ? userInfo.nickname : "未登录" }}</div>
            <!-- <el-dropdown-item command="/org/me">工作区</el-dropdown-item> -->
            <el-dropdown-item command="/form/me/co">外部协作</el-dropdown-item>
            <el-dropdown-item command="/contact/me">我的联系人</el-dropdown-item>
            <el-dropdown-item command="/reply/me">我的答复</el-dropdown-item>
            <el-dropdown-item command="/user/setting">设置</el-dropdown-item>
            <el-dropdown-item v-if="token" command="/logout" class="border-t">退出</el-dropdown-item>
            <el-dropdown-item v-if="!token" command="/login" class="border-t">登录</el-dropdown-item>
            <div v-show="showWxsupport" class="wxsupport border-t">
              <div id="wxsupport-box" class="has-bg-white text-center py-3 px-5 ">
                <div>微信客服</div>
                <div class="has-text-grey-light my-1 is-size-7">工作日：9:00 ~ 17:00</div>
                <a
                  class="my-1"
                  href="https://work.weixin.qq.com/kfid/kfc4c8482f0f4854c58"
                  target="_blank"
                >点击详询</a>
                <div class="has-text-grey-light is-size-7 my-1">或微信扫一扫详询哦</div>
                <img class="mt-2_5" src="//bahuyun.com/assets/qrcode.png" style="width: 150px;">
              </div>
            </div>
            <div class="row-wrap px-5 is-fs-s border-t has-text-grey-light">
              <div class="my-3 mr-2_5 cursor-hand has-text-light" @click="showWxsupport = !showWxsupport">微信客服</div>
              <a href="//bahuyun.com/bd-doc" class="my-3 mr-2_5 cursor-hand grey-link">帮助文档</a>
              <div class="has-text-light my-3 mr-2_5">@{{ new Date().getFullYear() }} bahuyun.com</div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <DlgSetMobile v-model="dlgSetMobile.val" :params="dlgSetMobile.params" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobileScreen, openPage } from '@/utils/index'
import DlgSetMobile from '@/components/DlgSetMobile.vue'

export default {
  name: 'Header',
  components: {
    DlgSetMobile
  },
  props: {
    isWide: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeIndex: '1',
      hasLeftbar: false,
      showWxsupport: false,
      dlgSetMobile: {
        val: {
          visible: false
        },
        params: {
          title: '验证手机号',
          msg: '根据国家相关法规，使用本平台请先验证手机号！',
          msgType: 'warning',
          canClose: false
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'userInfo',
      'orgInfo'
    ]),
    logoURL() {
      return process.env.VUE_APP_WEBAPP_BASE_URL + `/assets/logo.png`
    },
    showBack() {
      // const list = ['FormOrgMe', 'Login', 'Register', 'ResetPassword']
      // const show = !list.includes(this.$route.name)
      const show = isMobileScreen() // isMobWechat()
      return show
    }
  },
  async mounted() {
    console.log('Header')
    this.hasLeftbar = !!document.querySelector('#leftbar')

    // 验证手机号
    if (this.token && !this.userInfo.mobile && this.orgInfo) {
      const res = await this.$store.dispatch('user/getUserInfo')
      if (!res.mobile) {
        this.onSetMobile()
      }
    }
  },
  methods: {

    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push({ path: '/login' })
    },
    handleSelect(key) {
      console.log(key)
      if (key === '/logout') {
        this.logout()
      } else if (key === 'home') {
        window.location.href = 'https://bahuyun.com/bd-home'
      } else if (key === 'price') {
        window.location.href = 'https://bahuyun.com/bd-price.html'
      } else if (key === 'help') {
        window.location.href = 'https://bahuyun.com/bd-doc'
      } else if (key === 'order-create') {
        openPage({
          name: 'OrderCreate',
          query: { org_id: this.$route.params.id }
        }, this)
      } else {
        this.$router.push({ path: `${key}` })
      }
    },
    onShowLeftbarDrawer() {
      console.log(this.$store.state.app.showLeftbarDrawer)
      this.$store.dispatch('app/setShowLeftbarDrawer', !this.$store.state.app.showLeftbarDrawer)
    },
    onBack() {
      console.log('onBack')

      window.popstateSignal = false
      this.$router.back()
      setTimeout(() => {
        console.log()
        console.log('onBack timeout:' + window.popstateSignal)
        if (!window.popstateSignal) {
          window.location.href = 'https://bahuyun.com/bd-home'
        }
      }, 1000)
    },
    onSetMobile() {
      const that = this
      that.dlgSetMobile.val.visible = true
    }
  }
}

// 验证手机，在header中添加不能关闭的验证手机弹窗
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid #d9d9d9;
  background: #fff;
  color:#606266;
  // position: relative;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 800;
  height:50px;
  line-height: 50px;
}
// ::v-deep {
//   .el-popper {
//     margin-top: 0px!important;
//   }
// }

</style>
